/** @format */

import MapIcon from '@/assets/icons/card-room-map-pin-icon.svg';
import { MapRoomLocation } from '@/components/shared/MapRoomLocation';
import { useDelayedUnmount } from '@/ducks/general/hooks/useDelayedUnmount';
import { useWindowWidth } from '@/ducks/general/hooks/useWindowWidth';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React, { FunctionComponent as FC, useEffect } from 'react';
import { Icon } from '../../Icon';
import { useCardRoomContext } from '../context';
import { ButtonPlayVR, Desktop, Mobile, MobileMapContainer, WrapperVR } from './index.style';
import { SlideBottomSheet } from './SlideBottomSheet';

export const MapSlide: FC<MapSlideProps> = ({ mapState }) => {
  const { t } = useAppTranslation();

  const windowWidth = useWindowWidth();
  const [isMapActive, setIsMapActive] = mapState;
  const shouldRenderPanel = useDelayedUnmount(isMapActive, 400);

  const { room } = useCardRoomContext();

  useEffect(() => {
    if (!windowWidth || windowWidth <= 1160) return;
    setIsMapActive(true);
  }, [windowWidth]);

  return (
    <>
      <Desktop $fullScreen>
        <MapRoomLocation room={room!} />
      </Desktop>
      <Mobile $fullScreen>
        <MobileMapContainer>
          {!isMapActive && (
            <WrapperVR>
              <MapRoomLocation room={room!} showZoom={false} scrollZoom={false} disableMovement />
              <ButtonPlayVR onClick={() => setIsMapActive(true)}>
                {t('plp.card.modal.explore_map' as TTranslation)}
                <Icon icon={MapIcon} color="#344054" width={24} height={24} />
              </ButtonPlayVR>
            </WrapperVR>
          )}
          {shouldRenderPanel && (
            <SlideBottomSheet
              label={t('plp.card.modal.tabs.map' as TTranslation)}
              onClose={() => setIsMapActive(false)}
              isOpen={isMapActive}
            >
              <MapRoomLocation room={room!} />
            </SlideBottomSheet>
          )}
        </MobileMapContainer>
      </Mobile>
    </>
  );
};

export interface MapSlideProps {
  mapState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}
